import { Keyword } from '../types';

const filterKeywords = (value: string, keywords: Keyword[]): Keyword[] => {
  if (!value) return keywords;

  const lowerInput = value.toLowerCase();
  return keywords.filter(
    (keyword) =>
      keyword.Title?.toLowerCase().includes(lowerInput) ||
      keyword.Instructions?.toLowerCase().includes(lowerInput),
  );
};

export default filterKeywords;
